import React from 'react';

import Shimmer from 'components/Shimmer';

import { Container, Filter, Checkbox } from './styles';

const LoaderDesktop = () => (
  <Container>
    <Filter>
      <Filter.Title>
        <Shimmer>Escalas</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>Directo</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>1 Escala</Shimmer>
        </li>
      </ul>
    </Filter>

    <Filter>
      <Filter.Title>
        <Shimmer>Horario de salida</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>

    <Filter>
      <Filter.Title>
        <Shimmer>Horario de salida</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>

    <Filter>
      <Filter.Title>
        <Shimmer>Compania aerea</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>Avianca</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>LATAM Airlines</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Viva Air</Shimmer>
        </li>
      </ul>
    </Filter>

    <Filter>
      <Filter.Title>
        <Shimmer>Precio</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>
  </Container>
);

export default LoaderDesktop;
